import { Suspense, useEffect } from 'react'  // ⭐ 추가
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { AuthProvider } from './contexts/AuthContext'
import { AlertProvider } from './contexts/AlertContext'
import { ConfirmProvider } from './contexts/ConfirmContext';
import { CareRequestProvider } from './contexts/CareRequestContext';
import { NavigationProvider } from './contexts/NavigationContext';
import ScrollToTop from './components/base/ScrollToTop';
import { initFCMTokenListener } from './services/fcm';

function App() {

  useEffect(() => {
    initFCMTokenListener();
  }, []);

  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <ScrollToTop />
      <NavigationProvider>
        <AuthProvider>
          <AlertProvider>
            <ConfirmProvider>
              <CareRequestProvider>
                {/* ⭐ Suspense로 감싸기 */}
                <Suspense fallback={<div className="min-h-screen bg-white" />}>
                  <AppRoutes />
                </Suspense>
              </CareRequestProvider>
            </ConfirmProvider>
          </AlertProvider>
        </AuthProvider>
      </NavigationProvider>
    </BrowserRouter>
  )
}

export default App